/**
 * RP80 → RP83 — un bloc de « Ma semaine » : titre, nombre, lignes cliquables par chantier.
 * `cle` : clé du bloc dans GET /api/me/ma-semaine (voir maSemaine.js › BLOCS).
 */
import { Link } from 'react-router-dom';
import { Warning } from '@phosphor-icons/react';
import { BLOCS } from './maSemaine';

export default function MaSemaineBloc({ cle, items = [], total, max = 6, titre, vide, action }) {
  const def = BLOCS[cle];
  if (!def) return null;
  const n = typeof total === 'number' ? total : items.length;
  return (
    <div className="border border-[#E0E0DB] bg-white" data-testid={`ma-semaine-bloc-${cle}`}>
      <div className="px-4 py-3 border-b border-[#E0E0DB] flex items-center justify-between gap-2">
        <h3 className="text-sm font-bold uppercase tracking-wider text-[#6B6B6B]">{titre || def.titre}</h3>
        <span className={`text-xs font-bold px-2 py-0.5 ${n > 0 && def.alerte ? 'bg-[#FFEBEE] text-[#8B3A3A]' : 'bg-[#F5F5F3] text-[#4A4A4A]'}`}>
          {n}
        </span>
      </div>
      {items.length === 0 ? (
        <p className="text-sm text-[#9A9A9A] text-center py-5">{vide || 'Rien en attente'}</p>
      ) : (
        <div className="divide-y divide-[#F0F0EC]">
          {items.slice(0, max).map((x) => (
            <div key={`${cle}-${x.id || x.lot_id}-${x.chantier_id}`} className="flex items-start gap-2 px-4 py-2.5 hover:bg-[#FAFAF9]">
              <Link to={def.lien(x)} className="flex-1 min-w-0">
                <p className="text-sm font-medium text-[#2C2C2C] truncate">
                  {def.alerte && <Warning size={12} className="inline mr-1 text-[#8B3A3A]" />}
                  {def.texte(x)}
                </p>
                <p className="text-xs text-[#6B6B6B] truncate">
                  <span className="text-[#1E3A5F]">{x.chantier_name}</span>
                  {def.detail(x) ? ` · ${def.detail(x)}` : ''}
                </p>
              </Link>
              {action && action(x)}
            </div>
          ))}
          {n > max && (
            <p className="px-4 py-2 text-xs text-[#9A9A9A]">+ {n - max} autre{n - max > 1 ? 's' : ''}</p>
          )}
        </div>
      )}
    </div>
  );
}
